module.exports = __webpack_public_path__ + "img/add_box.e01f75d0.svg";